/** @format */

import React, { Component } from 'react';
import {
  Segment,
  Divider,
  Header,
  Table,
  Button,
  Icon,
} from 'semantic-ui-react';
import { getDateFromTimestamp } from '../../../../helpers/getDateFromTimestamp';
import { observer, inject } from 'mobx-react';

@inject('RequestsStore', 'UserStore')
@observer
class RequestInfo extends Component {
  render() {
    let { UserStore, RequestsStore } = this.props;
    const clientCode =
      RequestsStore.currentRequest &&
      RequestsStore.currentRequest.data &&
      RequestsStore.currentRequest.data._client.slice(-6);
    return (
      <Segment className="reqPart-box" key="add-part-button">
        <Header as="h3">Informazioni({clientCode})</Header>
        <Divider />
        <Table compact basic="very" fixed celled>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <small>
                  <strong>Creata il</strong>
                </small>
                <br />
                {RequestsStore.currentRequest.data.timestamp
                  ? getDateFromTimestamp(
                      RequestsStore.currentRequest.data.timestamp,
                    )
                  : 'Da Inoltrare'}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Ultima modifica</strong>
                </small>
                <br />
                {RequestsStore.currentRequest.data.lastModified
                  ? getDateFromTimestamp(
                      RequestsStore.currentRequest.data.lastModified,
                    )
                  : 'Da Inoltrare'}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Venditore</strong>
                </small>
                <br />
                {RequestsStore.currentRequest.data.seller
                  ? RequestsStore.currentRequest.data.seller
                  : UserStore.user.name}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <small>
                  <strong>Progresso Richiesta</strong>
                </small>
                <br />
                {RequestsStore.currentRequest.data.progress
                  ? RequestsStore.currentRequest.data.progress
                  : 'da inoltrare'}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Provenienza</strong>
                </small>
                <br />
                {RequestsStore.currentRequest.data.fromPlace
                  ? RequestsStore.currentRequest.data.fromPlace
                  : UserStore.user.location}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>In carico a</strong>
                </small>
                <br />
                {RequestsStore.currentRequest.data.toPlace
                  ? RequestsStore.currentRequest.data.toPlace
                  : 'da inoltrare'}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell colSpan={3}>
                <small>
                  <strong>Note</strong>
                </small>
                <br />
                {RequestsStore.currentRequest.data.note
                  ? RequestsStore.currentRequest.data.note
                  : '-'}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        <Button
          onClick={() => RequestsStore.toggleRequestNoteModal()}
          fluid
          size="small"
          color="green"
        >
          <Icon name="pencil" /> Modifica Note
        </Button>
      </Segment>
    );
  }
}

export default RequestInfo;
